import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage'; // 🔸 Storage importu

const firebaseConfig = {
  apiKey: 'AIzaSyAmrrkAkmVfoRXuX_WLj-I04fIdEWclic4',
  authDomain: 'hacialikara.firebaseapp.com',
  projectId: 'hacialikara',
  storageBucket: 'hacialikara.appspot.com',
  messagingSenderId: '211273021756',
  appId: '1:211273021756:web:92fd443820bc8319d44639',
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app); // 🔸 Storage instance

const provider = new GoogleAuthProvider();

export { app, db, auth, provider, storage }; // 🔸 storage'ı export et
